










































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import authModule from '@/store/modules/authModule';
import Version from '@/components/Version.vue';
import {getVersion} from '@/api/versionApi';

@Component({
  components: {
    Version,
  },
})
export default class NavigationDrawerItems extends Vue {
  @Prop()
  mini!: boolean;

  app_name = 'Opti-Repair';

  async created() {
    const data = await getVersion();
    if ('name' in data) {
      this.app_name = data['name'];
    }
    document.title = this.app_name;
  }

  get showMiniButton() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return false;
      case 'sm':
        return false;
      case 'md':
        return false;
      case 'lg':
        return true;
      case 'xl':
        return true;
      default:
        return true;
    }
  }

  get username() {
    return authModule.getLoggedInUser;
  }

  async onLogout() {
    const currentUrl = this.$route.path;
    await authModule.logout(currentUrl);
  }
}
